"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../theme");
exports.CSS = {
    item: 'c-Menu__Item',
    hidden: 'c-Menu__Item--Hidden',
    disabled: 'c-Menu__Item--Disabled',
    selected: 'c-Menu__Item--Selected'
};
exports.Style = (_a = {},
    _a[exports.CSS.item] = {
        color: theme_1.DefaultTheme.font.color.supporting,
        'font-family': theme_1.DefaultTheme.font.family,
        'font-size': theme_1.DefaultTheme.font.size,
        'line-height': theme_1.DefaultTheme.space(8),
        display: 'flex',
        'align-items': 'center',
        padding: theme_1.DefaultTheme.space(2) + ' ' + theme_1.DefaultTheme.space(3),
        cursor: 'pointer',
        '& i': {
            'margin-right': theme_1.DefaultTheme.space(4)
        },
        '&:active': {
            'background-color': theme_1.DefaultTheme.background.mediumGrey
        },
        '&:focus': {
            'background-color': theme_1.DefaultTheme.background.lightGrey
        }
    },
    _a["".concat(exports.CSS.item, ".").concat(exports.CSS.disabled)] = {
        cursor: 'default',
        color: theme_1.DefaultTheme.font.color.disabled,
        '&:hover': {
            'background-color': theme_1.DefaultTheme.background.lightGrey
        },
        '&:active': {
            'background-color': theme_1.DefaultTheme.background.grey
        }
    },
    _a["".concat(exports.CSS.item, ".").concat(exports.CSS.selected)] = {
        'background-color': theme_1.DefaultTheme.background.lightGrey
    },
    _a["".concat(exports.CSS.item, ".").concat(exports.CSS.selected, ".").concat(exports.CSS.disabled)] = {
        color: theme_1.DefaultTheme.font.color.disabled
    },
    _a[exports.CSS.hidden] = {
        display: 'none'
    },
    _a);
//# sourceMappingURL=menu.item.style.js.map